/// <reference path="empresasStand.js" />
/// <reference path="../scripts/rsvp.js" />
var objMapa;

function GetMapa() {
    if (objMapa == undefined)
    {
        objMapa = new Mapa();
    }
    return objMapa;
}


function Mapa() {
};
Mapa.prototype = {

    arrayPabellones : new Array(),
    puntos : Array(),
    NombreImagen : '',
    xmindgn : 0, 
    ymindgn : 0, 
    anchodgn : 0, 
    altodgn : 0, 
    anchopix : 0, 
    altopix : 0, 
    Yoffset : 0,
    STAND_Recinto : '',
    pabellones : new Array(),
    stands : new Array(),
    xmindgn_stand: 0,
    ymindgn_stand: 0,
    anchodgn_stand: 0,
    altodgn_stand: 0,
    gstand: 0,
    vPabellonActual : '',
    idCapaMarker : 'stand-in-map',
    idCapaFavorito : 'stand-in-map-fav',
    idMarker: 'marker',
    tipoMapa: '',

    setEstilosMapasPIM: function () {
        $("[pim]").each(function() {
            valuePIM = this.getAttribute("pim");
            if (this.className.indexOf(valuePIM) == -1)
                this.className += " " + valuePIM;
        });
    },
    BuscarCentroides: function(Stand) {
        for (i = 0; i < this.stands.length; i++) {
            if (this.stands[i].numstand == Stand)
                return this.stands[i];
        }
    },
    BuscarStandPorEmpresa: function(idEmpresa) {
        var arrayStands = new Array();
        //Marco, el código que viene en la exportación es del tipo XXX_XX_XX, mientras que el que esta en los ficheros de coordenadas es XXX_XX
        var res = idEmpresa.split("_");
        var codEmpresa = res[0] + "_1"; //"_1_0";
        for (i = 0; i < this.stands.length; i++) {
            if (this.stands[i].codempr == codEmpresa) {
                arrayStands.push(this.stands[i]);
            }
        }
        return arrayStands;
    },
    BuscarStandPorEmpresaStand: function (idEmpresa, stand) {
        var arrayStands = new Array();
        //Marco, el código que viene en la exportación es del tipo XXX_XX_XX, mientras que el que esta en los ficheros de coordenadas es XXX_XX
        //stand tendrá el STAND, en caso de ser Coexpositor 
        //stand tendrá x en caso de ser Expositor u otros 
        var res = idEmpresa.split("_");
        var codEmpresa = res[0] + "_1"; //"_1_0";
        if (stand === "X") {
            for (i = 0; i < this.stands.length; i++) {
                if (this.stands[i].codempr == codEmpresa) {
                    arrayStands.push(this.stands[i]);
                }
            }
        }
        else {
            for (i = 0; i < this.stands.length; i++) {
                if (this.stands[i].codempr == codEmpresa && this.stands[i].numstand === stand) {
                    arrayStands.push(this.stands[i]);
                }
            }
        }
        return arrayStands;
    },
    CargarRecinto: function (onTerminate) {
        var cadena = '';
        var mslink = '',prefimg = '';
        var objSelf = this;
        $.ajax({
            type: "GET",
            url:  GetObjConfiguracion().GetRutaFichero("X", "imgrecinto.xml"),  
            dataType: "xml",
            success: function (xml) {
                var contador = 0;

                $(xml).find('IMG').each(function () {
                    objSelf.NombreImagen = $(this).attr('NOMBRE');
                    objSelf.xmindgn = parseFloat($(this).attr('xmindgn'));
                    objSelf.ymindgn = parseFloat($(this).attr('ymindgn'));
                    objSelf.anchodgn = parseFloat($(this).attr('anchodgn'));
                    objSelf.altodgn = parseFloat($(this).attr('altodgn'));
                    objSelf.anchopix = parseFloat($(this).attr('anchopix'));
                    objSelf.altopix = parseFloat($(this).attr('altopix'));
                });

                $(xml).find('IMG').each(function () {
                    $(this).find('PAB').each(function () {
                        objSelf.puntos[contador] = new punto();
                        objSelf.puntos[contador].inicializa($(this).attr('mslink'), $(this).attr('prefimg'));
                        $(this).find('V').each(function () {
                            objSelf.puntos[contador].addcoordenada(parseFloat($(this).attr('x')), parseFloat($(this).attr('y')));
                        });
                        contador++;
                    });
                });
                if (onTerminate) onTerminate();
            }
        })
    },    
    LoadStands: function () {
        var objSelf = this;
        setTimeout(function () {
            if (objSelf.STAND_Recinto != "") {
                objSelf.PintarLocalizadorStand(objSelf.gstand, $('#' + objSelf.idCapaMarker), objSelf.idMarker, true);
            }
            objSelf.tipoMapa = 'P';
            objSelf.tratamientoFavoritos(GetFavoritos().MostrarFavoritos);
        }, 100);
        objSelf.RepintarMarcadores();
    },

    LoadMapa: function () {
        var objSelf = this;
        if (GetObjConfiguracion().verImpresion)
            var MostrarFavoritos = GetFavoritos().MostrarFavoritos;
        setTimeout(function () {
            if (objSelf.STAND_Recinto != "") {
                // Sólo se pinta el marker de la empresa en ajax_plano.html cuando se hace click desde la ficha de la empresa, y no desde la opción de menú planos.
                objSelf.PintarLocalizadorPlano(objSelf.STAND_Recinto, $('#' + objSelf.idCapaMarker), objSelf.idMarker, true);
                GetFavoritos().MostrarFavoritos = false;
            } else {
                // Se deben mostrar desde la opción Planos del menú principal
                GetFavoritos().MostrarFavoritos = true;
            }
            $('#chkFavoritos').attr('checked', GetFavoritos().MostrarFavoritos);
            objSelf.tipoMapa = 'R';
            if (GetObjConfiguracion().verImpresion)
                objSelf.tratamientoFavoritos(MostrarFavoritos);
            else
                objSelf.tratamientoFavoritos(GetFavoritos().MostrarFavoritos);

        }, 100);
        objSelf.RepintarMarcadores();
    },

    PintarLocalizadorStand: function (pstand, capa, idMarker, mostrarFav) {
        var objSelf = this;
        if (pstand != null && pstand != "undefined" && pstand != "" && ($('#mappab').length)) {
            var anchopix = ($("#MapaStands").width());
            var altopix = $("#MapaStands").height();
            //var anchopix = ($("#mappab").width());
            //var altopix = $("#mappab").height();

            var Yoffset;
            var Xoffset;
            //en ie8 a veces cuando va a pintar no está definido el offset
            if ($("#MapaStands").offset()) {
                Yoffset = $("#MapaStands").offset().top;
                Xoffset = $("#MapaStands").offset().left;
            }
            //if ($("#mappab").offset()) {
            //    Yoffset = $("#mappab").offset().top;
            //    Xoffset = $("#mappab").offset().left;
            //}

            var Centroide = this.BuscarCentroides(pstand);

            if (Centroide != 'undefined' && Centroide != null) {
                if (Centroide.pabellon == vPabellonActual) {
                    var Px = ((Centroide.cx - this.xmindgn_stand) / this.anchodgn_stand) * anchopix;
                    var Py = (((Centroide.cy) - this.ymindgn_stand) / this.altodgn_stand) * altopix;
                    Py = altopix - Py + Yoffset;
                    Px = Px + Xoffset;
                    capa.css({ "top": +Py - 32, "left": +Px - 9 }); //36 x32

                    $('#' + idMarker).click(function ()
                    {
                        GetObjEmpresasStand(false).MostrarEmpresasStand(
                            parseFloat(capa.css("left")) + 9,
                            parseFloat(capa.css("top")) + 32,
                            objSelf.stands,
                            {
                                anchodgn_stand: objSelf.anchodgn_stand,
                                altodgn_stand: objSelf.altodgn_stand,
                                xmindgn_stand: objSelf.xmindgn_stand,
                                ymindgn_stand: objSelf.ymindgn_stand
                            },
                            1);
                    });

                    if (mostrarFav) {
                        capa.show();
                    }
                }
            }
        }
    },   
    PintarLocalizadorPlano: function (STAND, capa, idMarker, mostrarFav) {
        var objSelf = this;
        if (STAND != null && STAND != "undefined" && STAND != "" && ($('#MapaPabellones').length)) {
            var anchopix = ($("#MapaPabellones").width());
            var altopix = $("#MapaPabellones").height();
            var Yoffset;
            var Xoffset;
            //en ie8 a veces el offset no está definido
            if ($("#MapaPabellones").offset()) {
                Yoffset = $("#MapaPabellones").offset().top;
                Xoffset = $("#MapaPabellones").offset().left;
            }
            var Centroide = this.BuscarCentroides(STAND);
            if (Centroide != 'undefined' && Centroide != null) {
                var FC = 2.8;
                var Px = ((Centroide.cx - this.xmindgn) / this.anchodgn) * anchopix;
                var Py = (((Centroide.cy + FC) - this.ymindgn) / this.altodgn) * altopix;
                Py = altopix - Py + Yoffset;
                Px = Px + Xoffset;
                capa.css({ "top": +Py - 32, "left": +Px - 9 }); //36 x32 

                $('#' + idMarker).click(function () {
                    objSelf.CargaPlanoPabellon(parseFloat(capa.css("left")) + 9, parseFloat(capa.css("top")) + 32);
                });

                if (mostrarFav) {
                    capa.show();
                }
            }
        }
    },

    PabellonActual: function (XDGN, YDGN) {
        var puntoTest = { x: XDGN, y: YDGN };
         var iPabellon = '';
         for (i = 0; i < this.puntos.length; i++) {

             if (isPointInPoly(this.puntos[i].coordenadas, puntoTest)) {
                 iPabellon = this.puntos[i].prefimg;
                 break;
             }
         }
         return iPabellon;
    },
    CargaPlanoPabellon: function (X, Y) {
        var XDGN = 0;
        var YDGN = 0;
        var anchopix = $("#MapaPabellones").width();
        var altopix = $("#MapaPabellones").height();
        var Yoffset;
        var Xoffset;
        if ($("#MapaPabellones").offset())
        {
            Yoffset = $("#MapaPabellones").offset().top;
            Xoffset = $("#MapaPabellones").offset().left;
        }
        Y = altopix - Y + Yoffset;
        X = X - Xoffset;
        XDGN = ((X / anchopix) * this.anchodgn) + this.xmindgn;
        YDGN = ((Y / altopix) * this.altodgn) + this.ymindgn;
        var PabellonPulsado = this.PabellonActual(XDGN, YDGN);
        if (PabellonPulsado != null && PabellonPulsado != "undefined" && PabellonPulsado != "" && PabellonPulsado.length > 0) {
            if (this.STAND_Recinto != null && this.STAND_Recinto != "undefined" && this.STAND_Recinto != "" && this.STAND_Recinto.length > 0)
            {
                GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_PABELLON, '#MAPA_PABELLON?p=' + PabellonPulsado + '&s=' + this.STAND_Recinto);
                //window.location.hash = '#MAPA_PABELLON?p=' + PabellonPulsado + '&s=' + this.STAND_Recinto;

                //this.IniciarMapaPabellon(PabellonPulsado, STAND_Recinto);
                //var strRuta = "waCatalogoWeb/mapa_pabellon.html?+p= " + PabellonPulsado + "&s=" + STAND_Recinto;
            }
            else {
                GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_PABELLON, '#MAPA_PABELLON?p=' + PabellonPulsado);
                //window.location.hash = '#MAPA_PABELLON?p=' + PabellonPulsado;
                //this.IniciarMapaPabellon(PabellonPulsado);
                //var strRuta = "waCatalogoWeb/mapa_pabellon.html?p=" + PabellonPulsado;
            }
            /*$.ajax({
                url: strRuta,
                success: function (data) {
                    $("#divCuerpo").html(data);
                }
            });*/
        }
     },
    BuscarPabellon: function(Pabellon) {
        for (i = 0; i < this.pabellones.length; i++) {
            if (this.pabellones[i].prefimg == Pabellon)
                return {
                    xmin: this.pabellones[i].xmindgn, ymin: this.pabellones[i].ymindgn,
                    ancho: this.pabellones[i].anchodgn, alto: this.pabellones[i].altodgn
                }
        }
    },
    InicializaCoordenadasDGNPabellon:function(Pabellon) {
        var Coor = this.BuscarPabellon(Pabellon);
        vPabellonActual = Pabellon;
        if (Coor != 'undefined' && Coor != "undefined" && Coor != null) {
            this.xmindgn_stand = Coor.xmin;
            this.ymindgn_stand = Coor.ymin;
            this.anchodgn_stand = Coor.ancho;
            this.altodgn_stand = Coor.alto;
        }
    },
    CargarPabellones: function (onTerminate) {
        var objSelf = this;
        $.ajax({
        type: "GET",
        url: GetObjConfiguracion().GetRutaFichero("X", "imgstands.xml"),
        dataType: "xml",
        success: function (xml) {
            var stand1;
            var pabellon1;
            $(xml).find('PAB').each(function () {
                pabellon1 = new pabellon();
                pabellon1.inicializa(parseFloat($(this).attr('xmindgn')),
                                        parseFloat($(this).attr('ymindgn')),
                                        parseFloat($(this).attr('anchodgn')),
                                        parseFloat($(this).attr('altodgn')),
                                        $(this).attr('prefimg'));
                objSelf.pabellones.push(pabellon1);

                $(this).find('ST').each(function () {
                    stand1 = new stand();
                    stand1.inicializa($(this).attr('mslink'),
                                            $(this).attr('numstand'),
                                            $(this).attr('codempr'),
                                            parseFloat($(this).attr('cx')),
                                            parseFloat($(this).attr('cy')), pabellon1.prefimg);
                    objSelf.stands.push(stand1);
                    $(this).find('V').each(function () {
                        //<V x="-15,9" y="-5,9"/>
                        stand1.addpunto(parseFloat($(this).attr('x')), parseFloat($(this).attr('y')));
                    })
                })
                if (onTerminate) onTerminate();
            })

        }
        })
    },
    tratamientoFavoritos:function(mostrarFav) {
        /* Gestiona si se debe mostrar o no el check de Favoritos, y además en caso de estar disponible la opción, se deben añadir dinámicamente
        los favoritos como elementos <li> en la lista <ul> de id "stand-in-map-recinto" */
        this.limpiarFavoritos();
        var objSelf = this;
        $('#chkFavoritos').unbind('click').bind('click', function () {
            if ($(this).is(':checked')) {
                GetFavoritos().MostrarFavoritos = true;                
            } else {
                GetFavoritos().MostrarFavoritos = false;
            }
            GetImpresionLocalStorage().setParametros();
            var mystand = sacaParametro('s', window.location.hash);
            var mypab = sacaParametro('p', window.location.hash);
            objSelf.RepintarMarcadores();
            if (GetObjConfiguracion().verPIM == 'S') {
                if (window.location.hash.indexOf("MAPA_FERIA") >= 0) {
                    if (mystand == "")
                        GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, '#MAPA_FERIA');
                    else
                        GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, '#MAPA_FERIA?s=' + mystand);
                }
                else {
                    if (mystand == "")
                        GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_PABELLON, '#MAPA_PABELLON?p=' + mypab );
                    else
                        GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_PABELLON, '#MAPA_PABELLON?p=' + mypab + '&s=' + mystand);
                }
            }
            else {
                if (GetObjConstantes()._MODO_PRUEBA) {
                    if (window.location.hash.indexOf("MAPA_FERIA") >= 0) {
                        window.open("impresion_plano.html?feria=" + GetObjConfiguracion().feria + "&s=" + mystand, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                    }
                    else {
                        window.open("impresion_pabellon.html?feria=" + GetObjConfiguracion().feria + "&s=" + mystand + "&p=" + mypab, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                    }
                }

                //            objSelf.mostrarFavoritos(GetFavoritos().MostrarFavoritos);DDC esta linea la he quitado porque en stands 
                //marcar y desmarcar el check de favoritos no oculta correctamente los marcadores
            }

        });

        //DDC no entiendo estos dos if pero por si las moscas no toco¿¿???
        if (!mostrarFav) {
            if (GetFavoritos().MostrarFavoritos) {
                $('#chkFavoritos').attr('checked', true);
            } else {
                $('#chkFavoritos').attr('checked', false);
            }
        } else {
            $('#chkFavoritos').attr('checked', true);
        }

        var arrayFavs = GetFavoritos().LoadArrayFavoritos();
        if (arrayFavs.length > 0) {
            for (var i = 0; i < arrayFavs.length; i++) {
                //var arrayStands = this.BuscarStandPorEmpresa(arrayFavs[i].id);
                var arrayStands = this.BuscarStandPorEmpresaStand(arrayFavs[i].id,arrayFavs[i].texto);
                this.crearFavoritos(arrayStands, mostrarFav);
            }
            $('#trataFavoritos').show();
        }
    },
    crearFavoritos: function (arrayFavoritos, mostrarFav) {
        // Se crean las capas para los favoritos. Una por favorito.
            var idCapa;
        var idMarkerFavorito;
        var capa;

        for (var j = 0; j < arrayFavoritos.length; j++) {
            idCapa = this.idCapaFavorito + GetFavoritos().NumFavoritos;
            idMarkerFavorito = 'fav' + GetFavoritos().NumFavoritos;
            capa = $('<div id="' + idCapa + '" class="pushpinFavorito"><li><img id="' + idMarkerFavorito + '" src="img/fav_marker.png" /></li></div>');
            capa.hide();
            if (arrayFavoritos[j].numstand != this.STAND_Recinto) {
                // Se añade el favorito sólo si no está visible ya la empresa
                $('#favoritos').append(capa);
                GetFavoritos().NumFavoritos++;
                if (this.tipoMapa == 'P')
                    this.PintarLocalizadorStand(arrayFavoritos[j].numstand, capa, idMarkerFavorito, mostrarFav);
                else
                    this.PintarLocalizadorPlano(arrayFavoritos[j].numstand, capa, idMarkerFavorito, mostrarFav);                
                
            }
        }
    },
    limpiarFavoritos:function () {
        // Se borran todas las capas de favoritos de ajax_plano.html
        GetFavoritos().NumFavoritos = 0;
        var arrayCapasFavoritos = $("div[id^=" + this.idCapaFavorito + "]");
        $.each(arrayCapasFavoritos, function (ind, capaFavorito) {
            $(capaFavorito).remove();
        });
    },
    mostrarFavoritos: function(mostrar) {
        // Función que muestra/oculta las capas de favoritos según marque o demsarque el check el usuario
        var arrayCapasFavoritos = $("div[id^=" + this.idCapaFavorito + "]");
        if (mostrar) {
            $.each(arrayCapasFavoritos, function (ind, capaFavorito) {
                $(capaFavorito).show();
            });
        } else {
            $.each(arrayCapasFavoritos, function (ind, capaFavorito) {
                $(capaFavorito).hide();
            });
        }

    },
    OcultaLocalizador: function () {
        $("#stand-in-map").hide();
    },
    IniciarMapaFeria: function (stand) {
        $("#MapaStands").css("display", "none");
        $("#MapaPabellones").css("display", "block");//aquí supongo tendrá que ir el estilo que correponda. ahora para pruebas block
        $('#wrapperMapa').css("display", "block");
        $('#wrapperPabellon').css("display", "none");
        $('#contenedorFicha').css("display", "none");
        
        //var STAND = getParameterByName('S');
        var STAND = stand;
        if (GetObjConfiguracion().verImpresion) 
            GetFavoritos().MostrarFavoritos = GetFavoritos().MostrarFavoritos;
        else 
            GetFavoritos().MostrarFavoritos = true;

        if (STAND != null && STAND != "undefined" && STAND != "") {

            var res = STAND.split(";");
            var myStand = res[0];
            this.STAND_Recinto = myStand;
            // Se recoloca en tiempo de ejecución para que no se monte el check de favoritos con la imagen del mapa (por el texto que tiene la imagen arriba a la izquierda)
            //$('#wrapperMapa').css('top', '75');
            //$('#wrapperMapa').css('height', Math.floor(screen.availHeight - (75 + 48)));

            //addeventoanalitics(GetObjConfiguracion().Feria, 'Mapa General', "Stand: " + STAND, 0); maem 24/11
        }
        else {
            this.STAND_Recinto = '';
            //addeventoanalitics(GetObjConfiguracion().Feria, 'Mapa General', 'Sin Stand', 0); maem 24/11
        }

        $("#map").click(function (e) {
            //console.log("X: "+e.pageX+" Y:"+e.pageY);
            GetMapa().CargaPlanoPabellon(e.pageX, e.pageY);
        });
    
        if (GetObjConfiguracion().EsRecintoPersonalizado())
            $('#MapaPabellones').attr("src", GetObjConfiguracion().GetRutaFichero("R", this.NombreImagen));
        else
            $('#MapaPabellones').attr("src", GetObjConfiguracion().GetRutaFichero("I", this.NombreImagen));
    },
    IniciarMapaPabellon: function (prefijo, stand) {
        var objSelf = this;

        $("#MapaPabellones").css("display", "none");
        $("#MapaStands").css("display", "block");//aquí supongo tendrá que ir el estilo que correponda. ahora para pruebas block
        $('#wrapperMapa').css("display", "none");
        $('#wrapperPabellon').css("display", "block");

        // PopUpStands.
        var dialog = $("#dialog-stands-empresas").dialog({
            dialogClass: 'noTitleStuff',
            autoOpen: false,
            modal: true
        });

        $("#mappab").click(function (e)
        {
            GetObjEmpresasStand(false).MostrarEmpresasStand(
                e.pageX,
                e.pageY,
                objSelf.stands,
                {
                    anchodgn_stand: objSelf.anchodgn_stand,
                    altodgn_stand: objSelf.altodgn_stand,
                    xmindgn_stand: objSelf.xmindgn_stand,
                    ymindgn_stand: objSelf.ymindgn_stand
                },
                1);
        });
        
        this.gstand = stand;
        if (this.gstand != "" && this.gstand != null && this.gstand != "undefined") {
            //addeventoanalitics(GetObjConfiguracion().Feria, 'Mapa Pabellon', prefijo + " Stand: " + this.gstand, 0); maem
        }
        else {
            //addeventoanalitics(GetObjConfiguracion().Feria, 'Mapa Pabellon', prefijo, 0); maem
        }

        if (prefijo != "" && prefijo != null && prefijo != "undefined") {
            this.InicializaCoordenadasDGNPabellon(prefijo);
            $('#MapaStands').attr("src", GetObjConfiguracion().GetRutaFichero("I", prefijo + '.PNG'));
        }

    },
    RepintarMarcadores: function(){
        this.OcultaLocalizador();
        this.limpiarFavoritos();
        
        if (this.tipoMapa == 'P') {
            if (this.gstand != "") this.PintarLocalizadorStand(this.gstand, $('#' + this.idCapaMarker), this.idMarker, true);
        }
        else {
            if (this.STAND_Recinto != "") this.PintarLocalizadorPlano(this.STAND_Recinto, $('#' + this.idCapaMarker), this.idMarker, true);
        }
                

        this.tratamientoFavoritos(GetFavoritos().MostrarFavoritos);
    }
}



function punto() { };
punto.prototype = {
    mslink: '', marcado: false, prefimg: '', 
    coordenadas: [],
    inicializa: function (i,j) {
        this.mslink = i; this.prefimg = j;
        this.coordenadas = new Array();
    },
    addcoordenada: function (x1, y1) {
        this.coordenadas.push({ x: x1, y: y1 });
    },
    pinta: function () { }
}


function stand() { };
stand.prototype = {
    mslink: '540548',
    numstand: '3E23',
    codempr: '750894_1',
    cx: 0,
    cy: 0,
    pabellon: '',
    puntos: [],
    inicializa: function (mslink, numstand, codempr, cx, cy, pab) {
        this.mslink = mslink;
        this.numstand = numstand;
        this.codempr = codempr;
        this.cx = cx;
        this.cy = cy;
        this.pabellon = pab;
        this.puntos = new Array();
    },
    addpunto: function (x1, y1) {
        this.puntos.push({ x: x1, y: y1 });
    }
};

function pabellon() { };
pabellon.prototype = {
    xmindgn: 0, ymindgn: 0, anchodgn: 0, altodgn: 0, prefimg: '',
    inicializa: function (a, b, c, d, e) {
        this.xmindgn = a; this.ymindgn = b; this.anchodgn = c; this.altodgn = d; this.prefimg = e;
    },
    pinta: function () { }
}





